import React, { Component } from "react";
import classnames from "classnames";
import styles from "./AnnexeCategories.local.scss";
import SidePageHeader from "../Common/SidePageHeader/SidePageHeader";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  initAnnexeCategories,
  setModifiedCategories,
  setStandardCategories,
  setCreatedCategories
} from "Actions";
import {
  fetchAnnexeCategories,
  updateAnnexeCategoriesState,
  updateAnnexeCategory,
  deleteAnnexeCategory,
  saveAnnexeCategory,
  fetchSupportedIndicatorVars
} from "Thunks";
import { push, goBack } from "react-router-redux";
import ItemCategory from "./ItemCategory";
import { onSuccess, onError } from "Utils";
import _ from "i18n";
import { SvgIcon } from "../Common/Icons";
import AnnexeCategorySideBar from "./AnnexeCategorySideBar";
import { ModalConfirm } from "tamtam-components";

class AnnexeCategoriesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "ALL",
      activated: null,
      labelsForm: { fr: "", en: "", nl: "" },
      originalLabels: [],
      labelsNeedsUpdate: false,
      labelsUpdating: false,
      isAddingCategory: false,
      originalAccount: null,
      selectedAccount: null,
      isOpenModalDelete: false,
      isOpenModal: false,
      idCateg: null
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("ANNEXE_CATEGORIES_SETTING"));

    dispatch(initAnnexeCategories());
    dispatch(fetchAnnexeCategories());
    dispatch(fetchSupportedIndicatorVars());
  }

  handleToggleEnablingStandardCategory = categId => {
    const {
      categories: { standard },
      modified,
      dispatch
    } = this.props;

    let newModified = modified;
    let newStandard = [...standard];

    for (let i = 0; i < standard.length; i++) {
      if (standard[i].id === categId) {
        if (standard[i].enabled === 1) {
          newStandard[i].enabled = 0;

          if (newModified.enabled.includes(categId)) {
            newModified.enabled = newModified.enabled.filter(
              id => id !== categId
            );
          } else {
            newModified.disabled.push(categId);
          }
        } else {
          newStandard[i].enabled = 1;

          if (newModified.disabled.includes(categId)) {
            newModified.disabled = newModified.disabled.filter(
              id => id !== categId
            );
          } else {
            newModified.enabled.push(categId);
          }
        }
        break;
      }
    }
    dispatch(setModifiedCategories(newModified));
    dispatch(setStandardCategories(newStandard));
  };

  handleToggleEnablingCreatedCategory = categId => {
    const {
      categories: { created, standard },
      modified,
      dispatch,
      backOffice
    } = this.props;

    let category = backOffice ? standard : created;
    let newModified = modified;
    let newCreated = [...category];

    for (let i = 0; i < category.length; i++) {
      if (category[i].id === categId) {
        if (category[i].enabled === 1) {
          newCreated[i].enabled = 0;

          if (newModified.enabled.includes(categId)) {
            newModified.enabled = newModified.enabled.filter(
              id => id !== categId
            );
          } else {
            newModified.disabled.push(categId);
          }
        } else {
          newCreated[i].enabled = 1;

          if (newModified.disabled.includes(categId)) {
            newModified.disabled = newModified.disabled.filter(
              id => id !== categId
            );
          } else {
            newModified.enabled.push(categId);
          }
        }
        break;
      }
    }
    dispatch(setModifiedCategories(newModified));
    dispatch(setCreatedCategories(newCreated));
  };

  handleToggleActivatedCategoryToUpdate = (
    categId,
    labels,
    selectedAccount
  ) => {
    // const { dispatch } = this.props;
    const { activated } = this.state;
    if (!activated || activated !== categId) {
      this.setState({
        activated: categId,
        labelsForm: labels,
        originalLabels: labels,
        isAddingCategory: false,
        labelsNeedsUpdate: false,
        originalAccount: selectedAccount,
        selectedAccount: selectedAccount
      });
      // dispatch(setLabelsForm({ fr: "", en: "", nl: "" }));
    } else {
      this.setState({
        activated: null,
        labelsForm: { fr: "", en: "", nl: "" },
        originalLabels: [],
        isAddingCategory: false,
        labelsNeedsUpdate: false,
        originalAccount: null,
        selectedAccount: null
      });
      // dispatch(setLabelsForm({ fr: "", en: "", nl: "" }));
    }
  };

  isLabelsNeedsUpdate = () => {
    setTimeout(() => {
      if (
        JSON.stringify(this.state.labelsForm) !==
        JSON.stringify(this.state.originalLabels)
      ) {
        this.setState({ labelsNeedsUpdate: true });
      } else {
        this.setState({ labelsNeedsUpdate: false });
      }
    }, 100);
  };

  resetLabels = () => {
    this.setState({
      labelsForm: this.state.originalLabels,
      labelsNeedsUpdate: false,
      selectedAccount: this.state.originalAccount
    });
  };

  onChangeLabelFormFr = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, fr: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeLabelFormEn = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, en: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeLabelFormNl = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, nl: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  handleUpdateCategory = type => {
    const { activated, labelsForm, selectedAccount } = this.state;
    const { dispatch, categories, backOffice } = this.props;

    let updatedCateg =
      type === "CREATED" && !backOffice
        ? [...categories.created]
        : [...categories.standard];

    if (
      selectedAccount &&
      (categories.standard.find(
        obj => obj.associatedAccount === selectedAccount && obj.id !== activated
      ) ||
        categories.created.find(
          obj =>
            obj.associatedAccount === selectedAccount && obj.id !== activated
        ))
    ) {
      onError("Compte / indicateur déjà associé à une autre catégorie.");
    } else {
      this.setState({
        labelsUpdating: true
      });
      dispatch(
        updateAnnexeCategory(activated, labelsForm, selectedAccount, type)
      ).then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("categoryUpdated")
          });

          // eslint-disable-next-line array-callback-return
          updatedCateg.map((item, i) => {
            if (item.id === activated) {
              updatedCateg[i].label = labelsForm;
              updatedCateg[i].associatedAccount = selectedAccount;
            }
          });

          if (type === "CREATED" && !backOffice) {
            dispatch(setCreatedCategories(updatedCateg));
          } else {
            dispatch(setStandardCategories(updatedCateg));
          }

          this.setState({
            activated: null,
            labelsForm: { fr: "", en: "", nl: "" },
            originalLabels: [],
            isAddingCategory: false,
            labelsUpdating: false,
            labelsNeedsUpdate: false,
            originalAccount: null,
            selectedAccount: null
          });
        },
        err => {
          onError(err.response.data.errors[0].message);
          this.setState({
            labelsUpdating: false
          });
        }
      );
    }
  };

  handleDeleteCategory = idCateg => {
    this.setState({ isOpenModalDelete: true });
    this.setState({ idCateg: idCateg });
  };

  handleClosePage = () => {
    const { dispatch, modified, backOffice } = this.props;

    if (modified.enabled.length === 0 && modified.disabled.length === 0) {
      if (backOffice) {
        dispatch(goBack());
      } else {
        dispatch(push("/folders"));
      }
    } else {
      this.setState({ isOpenModal: true });
    }
  };

  onChangeFilter = filter => {
    this.setState({
      filter: filter,
      isAddingCategory: false
    });
  };

  handleUpdateAnnexeCategoriesState = () => {
    const { dispatch } = this.props;
    dispatch(updateAnnexeCategoriesState()).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoriesStateUpdated")
        });
        dispatch(setModifiedCategories({ enabled: [], disabled: [] }));
      },
      err => onError(err.response.data.errors[0].message)
    );
  };

  renderStandardCategories = indicatorsOptionsSelect => {
    const {
      lng,
      categories: { standard },
      indicators
    } = this.props;

    const { filter } = this.state;

    return (
      <div className={classnames("row")}>
        {standard.map((item, i) => {
          return filter === "ALL" ||
            (filter === "ENABLED" && item.enabled === 1) ||
            (filter === "DISABLED" && item.enabled === 0) ? (
            <div
              key={`standard-${i}`}
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                state={"STANDARD"}
                item={item}
                lng={lng}
                handleToggleEnablingCategory={
                  this.handleToggleEnablingStandardCategory
                }
                associatedAccount={
                  item.associatedAccount
                    ? indicators.items.filter(
                        ({ code }) => code === item.associatedAccount
                      )
                    : []
                }
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                active={this.state.activated === item.id}
                indicators={indicatorsOptionsSelect}
                selectedAccount={this.state.selectedAccount}
                onChangeSelectedAccount={this.onChangeSelectedAccount}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateCategory}
                saving={this.state.labelsUpdating}
              />
            </div>
          ) : null;
        })}
      </div>
    );
  };

  renderCreatedCategories = indicatorsOptionsSelect => {
    const {
      lng,
      categories: { created, standard },
      indicators,
      dispatch,
      modified,
      backOffice
    } = this.props;

    const { filter, isOpenModalDelete, idCateg } = this.state;

    let category = backOffice ? standard : created;
    return (
      <div className={classnames("row")}>
        {category.map((item, i) => {
          return filter === "ALL" ||
            (filter === "ENABLED" && item.enabled === 1) ||
            (filter === "DISABLED" && item.enabled === 0) ? (
            <div
              key={`created-${i}`}
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                state={"CREATED"}
                item={item}
                lng={lng}
                handleToggleEnablingCategory={
                  this.handleToggleEnablingCreatedCategory
                }
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                active={this.state.activated === item.id}
                labelsForm={this.state.labelsForm}
                onChangeLabelFormFr={this.onChangeLabelFormFr}
                onChangeLabelFormEn={this.onChangeLabelFormEn}
                onChangeLabelFormNl={this.onChangeLabelFormNl}
                labelsNeedsUpdate={this.state.labelsNeedsUpdate}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateCategory}
                saving={this.state.labelsUpdating}
                handleDeleteCategory={this.handleDeleteCategory}
                deleting={this.props.deleting}
                associatedAccount={
                  item.associatedAccount
                    ? indicators.items.filter(
                        ({ code }) => code === item.associatedAccount
                      )
                    : []
                }
                indicators={indicatorsOptionsSelect}
                selectedAccount={this.state.selectedAccount}
                onChangeSelectedAccount={this.onChangeSelectedAccount}
                backOffice={backOffice}
              />
            </div>
          ) : null;
        })}
        <ModalConfirm
          type={"delete"}
          isOpen={isOpenModalDelete}
          onCancel={() => this.setState({ isOpenModalDelete: false })}
          onConfirm={() => {
            let updatedCateg = [...category];
            return new Promise((resolve, reject) => {
              dispatch(deleteAnnexeCategory(idCateg)).then(
                res => {
                  onSuccess(res, {
                    title: _("removeSuccess"),
                    body: _("categoryDeleted")
                  });
                  resolve(true);

                  let newModified = modified;
                  newModified.enabled = newModified.enabled.filter(
                    id => id !== idCateg
                  );
                  newModified.disabled = newModified.disabled.filter(
                    id => id !== idCateg
                  );

                  dispatch(setModifiedCategories(newModified));
                  if (backOffice) {
                    dispatch(
                      setStandardCategories(
                        updatedCateg.filter(({ id }) => id !== idCateg)
                      )
                    );
                  } else {
                    dispatch(
                      setCreatedCategories(
                        updatedCateg.filter(({ id }) => id !== idCateg)
                      )
                    );
                  }

                  this.setState({ isOpenModalDelete: false });
                },
                err => {
                  onError(err.response.data.errors[0].message);
                  reject(true);
                  this.setState({ isOpenModalDelete: false });
                }
              );
            }).catch(() => console.log("Oops errors!"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("deleteConfirmation")}
          text={_("deleteCategoryContent")}
          labelNo={_("cancel")}
          labelYes={_("Delete")}
          labelError={"Error"}
        />
      </div>
    );
  };

  onClickNewCategory = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    // document.getElementById("mainMenu").style.zIndex = 6;
    document.body.style.overflow = "hidden";

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({
      activated: null,
      labelsForm: { fr: "", en: "", nl: "" },
      originalLabels: { fr: "", en: "", nl: "" },
      isAddingCategory: true,
      labelsNeedsUpdate: 0,
      selectedAccount: null
    });
  };

  onCancelNewCategory = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    // document.getElementById("mainMenu").style.zIndex = 4;
    document.body.style.removeProperty("overflow");

    this.setState({
      isAddingCategory: false
    });
  };

  handleSaveNewCategory = () => {
    const { labelsForm, selectedAccount } = this.state;
    const { dispatch, categories, backOffice } = this.props;
    let category = backOffice ? categories.standard : categories.created;
    let updatedCateg = [...category];

    if (
      selectedAccount &&
      (categories.standard.find(
        obj => obj.associatedAccount === selectedAccount
      ) ||
        categories.created.find(
          obj => obj.associatedAccount === selectedAccount
        ))
    ) {
      onError("Compte / indicateur déjà associé à une autre catégorie.");
    } else {
      dispatch(saveAnnexeCategory(labelsForm, selectedAccount)).then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("categoryAdded")
          });

          updatedCateg.push({
            id: res.value.data.data[0],
            label: labelsForm,
            enabled: 1,
            associatedAccount: selectedAccount
          });

          if (backOffice) {
            dispatch(setStandardCategories(updatedCateg));
          } else {
            dispatch(setCreatedCategories(updatedCateg));
          }

          this.onCancelNewCategory();
        },
        err => {
          onError(err.response.data.errors[0].message);
        }
      );
    }
  };

  renderAddBubble = () => {
    const { isAddingCategory } = this.state;
    return (
      <div className="setting-bubbles">
        <div
          className={classnames(
            "circleSvg",
            isAddingCategory ? "active opened" : ""
          )}
          onClick={() => this.onClickNewCategory()}
        >
          <SvgIcon icon={"AddIcon"} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("add")}</span>
        </div>
      </div>
    );
  };

  onChangeSelectedAccount = selectedAccount => {
    this.setState({
      selectedAccount: selectedAccount ? selectedAccount.value : null
    });
  };

  componentWillUnmount(): void {
    this.onCancelNewCategory();
  }

  render() {
    const {
      fetching,
      fetched,
      modified,
      saving,
      indicators,
      dispatch,
      backOffice
    } = this.props;
    const { isAddingCategory, labelsForm, isOpenModal } = this.state;

    const indicatorsOptionsSelect =
      indicators.items &&
      indicators.items.map(indicat => {
        const code =
          indicat.code.slice(0, 3) === "#0_"
            ? indicat.code.slice(3)
            : indicat.code.slice(1);
        const indicator = code.concat(" : ".concat(indicat.label.fr));
        return { label: indicator, value: indicat.code };
      });

    return (
      <div className={classnames(styles.annexe_categories, "page-content")}>
        <SidePageHeader
          subHeader="manageCategories"
          withReturnButton={true}
          handleReturnTo={this.handleClosePage}
        />

        <div className={styles.categories_block}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("categoriesList")}</h2>
            <h3 className={styles.subtitle}>{_("actionsOnCategories")}</h3>
          </div>
          <div className={styles.tabs_block}>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "ALL" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("ALL")}
            >
              {_("all")}
            </div>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "ENABLED" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("ENABLED")}
            >
              {_("Activated")}
            </div>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "DISABLED" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("DISABLED")}
            >
              {_("Disabled")}
            </div>

            <button
              type="button"
              className={classnames(styles.save_button)}
              disabled={
                fetching ||
                (modified.enabled.length === 0 &&
                  modified.disabled.length === 0)
              }
              onClick={this.handleUpdateAnnexeCategoriesState}
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={saving ? styles.loading : ""}
              />
              {_("save")}
            </button>
          </div>

          {fetching &&
            indicators.fetching && (
              <div className={styles.ripple_loading_adapted}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            )}

          {fetched &&
            indicators.fetched &&
            !backOffice &&
            this.renderStandardCategories(indicatorsOptionsSelect)}

          {fetched && indicators.fetched && <div className={styles.divider} />}

          {fetched &&
            indicators.fetched &&
            this.renderCreatedCategories(indicatorsOptionsSelect)}
        </div>
        {fetched && indicators.fetched && this.renderAddBubble()}
        {fetched &&
          indicators.fetched && (
            <AnnexeCategorySideBar
              saving={saving}
              isAddingCategory={isAddingCategory}
              labelsForm={labelsForm}
              onCancelNewCategory={this.onCancelNewCategory}
              onChangeLabelFormFr={this.onChangeLabelFormFr}
              onChangeLabelFormEn={this.onChangeLabelFormEn}
              onChangeLabelFormNl={this.onChangeLabelFormNl}
              handleSaveNewCategory={this.handleSaveNewCategory}
              selectedAccount={this.state.selectedAccount}
              indicators={indicatorsOptionsSelect}
              onChangeSelectedAccount={this.onChangeSelectedAccount}
              backOffice={backOffice}
            />
          )}
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(push("/folders"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("exitConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  categories: state.annexeCategories.items,
  modified: state.annexeCategories.modified,
  fetching: state.annexeCategories.fetching,
  fetched: state.annexeCategories.fetched,
  saving: state.annexeCategories.saving,
  saved: state.annexeCategories.saved,
  deleting: state.annexeCategories.deleting,
  deleted: state.annexeCategories.deleted,
  indicators: state.indicators.suggestions,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(AnnexeCategoriesPage);



// WEBPACK FOOTER //
// ./src/components/AnnexeCategories/AnnexeCategoriesPage.js